<app-button-advanced
  [action]="resetChangesToolAction"
  [active]="['ResetDiff'].includes(stateManagerProjectService.currentTool!)"
  matTooltip="{{ 'viewer.Tools.ResetChanges' | translate }}"
  [matTooltipPosition]="'left'"
  [matTooltipDisabled]="resetChangesDisabled$ | async"
>
</app-button-advanced>
